var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72884 10.0832H8.24967C8.49279 10.0832 8.72595 9.98659 8.89786 9.81469C9.06976 9.64278 9.16634 9.40962 9.16634 9.1665V3.20817L6.87467 0.916504H2.74967C2.50656 0.916504 2.2734 1.01308 2.10149 1.18499C1.92958 1.3569 1.83301 1.59006 1.83301 1.83317V6.18734",
    stroke: "#1447E6",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 0.916504V2.74984C6.41699 2.99295 6.51357 3.22611 6.68548 3.39802C6.85739 3.56993 7.09054 3.6665 7.33366 3.6665H9.16699",
    stroke: "#1447E6",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13178 7.16199C6.22218 7.07158 6.29389 6.96426 6.34282 6.84614C6.39175 6.72802 6.41693 6.60142 6.41693 6.47357C6.41693 6.34572 6.39175 6.21912 6.34282 6.101C6.29389 5.98288 6.22218 5.87556 6.13178 5.78515C6.04137 5.69475 5.93405 5.62303 5.81593 5.57411C5.69781 5.52518 5.57121 5.5 5.44336 5.5C5.31551 5.5 5.18891 5.52518 5.07079 5.57411C4.95267 5.62303 4.84535 5.69475 4.75494 5.78515L2.45869 8.08232C2.34972 8.19123 2.26996 8.32585 2.22678 8.47374L1.84315 9.78915C1.83165 9.82859 1.83096 9.8704 1.84115 9.91019C1.85135 9.94999 1.87206 9.98631 1.90111 10.0154C1.93016 10.0444 1.96648 10.0651 2.00628 10.0753C2.04607 10.0855 2.08788 10.0848 2.12732 10.0733L3.44273 9.68969C3.59062 9.64651 3.72524 9.56675 3.83415 9.45778L6.13178 7.16199Z",
    stroke: "#1447E6",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHistory);
export default __webpack_public_path__ + "static/media/edit_history.72e96127f98a54d80a62f80e246aee79.svg";
export { ForwardRef as ReactComponent };